export const NO_COMPUTER_SELECTION = 'none';

export type DesktopTarget = {
  target_id: string;
  display_name: string;
  is_available: boolean;
};

export type DesktopTargetSelection =
  | { kind: typeof NO_COMPUTER_SELECTION }
  | { kind: 'target'; target: DesktopTarget }
  | { kind: 'dead'; targetId: string; target?: DesktopTarget };

export interface DesktopTargetSelectorState {
  visible: boolean;
  rosterStatus: 'loading' | 'failed' | 'ready';
  selection: DesktopTargetSelection;
  thisComputer: DesktopTarget | undefined;
  live: DesktopTarget[];
  dead: DesktopTarget[];
  /** Present when the user can provision a cloud Resident from the picker. */
  residentSetup?: { provisioning: boolean; setUp: () => void };
  setSticky: (next: string) => void;
  retry: () => void;
}

export interface DesktopTargetSelectorProps {
  desktopTarget: DesktopTargetSelectorState;
  disabled?: boolean;
  className?: string;
}

export const selectorValueForSelection = (selection: DesktopTargetSelection): string => {
  if (selection.kind === 'target') return selection.target.target_id;
  if (selection.kind === 'dead') return selection.targetId;
  return NO_COMPUTER_SELECTION;
};
